const pressReleaseHomepage = {
  displayField: 'title',
  name: 'Press Release Homepage',
  description: 'Landing page for press releases on Americas site',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'headerType',
      name: 'Header Type',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'None', 'Only Logo', 'Full Navigation' ] } ],
      defaultValue: { 'en-US': 'Full Navigation' },
      disabled: false,
      omitted: false
    },
    {
      id: 'footerType',
      name: 'Footer Type',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'None', 'Full Navigation' ] } ],
      defaultValue: { 'en-US': 'Full Navigation' },
      disabled: false,
      omitted: false
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'category' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'seo',
      name: 'Seo',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'featuredPressRelease',
      name: 'Featured Press Release',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'pressRelease' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'contentBlocks',
      name: 'Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'shopGridCarousel',
              'shortTextAndImage',
              'video',
              'videoGallery',
              'bigPictureCta',
              'stackedTextImageBlock',
              'textAndImageBlock',
              'variantStackedTextImageBlock',
              'flexCollar',
              'introTextBlock',
              'searchHero',
              'interiorHero',
              'threeColumn',
              'threeColumnContent',
              'wideTextImage',
              'blogHomepageFeaturedArticles',
              'shopNewestListings',
              'featuredPropertiesByLifestyle',
              'WideStackedTextImageBlock',
              'threeColumnTeams',
              'clientTestimonials',
              'contactForm',
              'statBlock',
              'valuePropCarousel',
              'jazzHr',
              'richText',
              'newsletterForm',
              'mediaContactInfo',
              'nearbyListings',
              'genericEmbed'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: {
    id: 'pressReleaseHomepage',
    version: 16,
    updatedAt: '2023-10-19T14:38:28.773Z'
  }
};
export default pressReleaseHomepage;